/**
 * 楽観ロック衝突 (AC-09) からの「最新を読み込み直す」確認ダイアログ。
 *
 * 未保存の変更を破棄して最新データを再取得するため、破壊操作として確認を挟む
 * (DiscardConfirmModal と同じ意匠だが文言・確定 label が異なるため専用コンポーネント
 * に分離)。
 */
import { useTranslation } from 'react-i18next'

import {
  DangerButton,
  HStack,
  TertiaryButton,
  Text,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConflictReloadConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const footer = (
    <HStack gap={3}>
      <TertiaryButton onClick={onCancel}>
        {t('common:action.cancel')}
      </TertiaryButton>
      <DangerButton onClick={onConfirm}>
        {t('page:demandForecastDaily.save.conflictReloadButton')}
      </DangerButton>
    </HStack>
  )

  return (
    <Modal
      footer={footer}
      isOpen={isOpen}
      onClose={onCancel}
      // 幅は UI 辞書 components.md `.ecl-modal` の 4 段 (既定 md)。 8080 に対応する画面が無いので既定の md
      size="md"
      title={t('page:demandForecastDaily.save.conflictReloadConfirmTitle')}
    >
      <Text>
        {t('page:demandForecastDaily.save.conflictReloadConfirmBody')}
      </Text>
    </Modal>
  )
}
